import { defineMessages } from 'react-intl';

export const INVITE_DOCTOR_FORM_KEY = '@@inviteDoctor';

export const LOCALIZED_STRINGS = defineMessages({
    WantToBookWith: {
        id: 'Profile.Components.InviteDoctorForm.WantToBookWith',
        defaultMessage: 'Want to book online with {professionalName}?',
    },
    CompleteTheForm: {
        id: 'Profile.Components.InviteDoctorForm.CompleteTheForm',
        defaultMessage: 'Complete the form and we\'ll let this doctor know you want to book with them on Zocdoc!',
    },
    MessageSent: {
        id: 'Profile.Components.InviteDoctorForm.MessageSent',
        defaultMessage: 'Message Sent!',
    },
    MessageSentDescription: {
        id: 'Profile.Components.InviteDoctorForm.MessageSentDescription',
        defaultMessage: 'We\'ll let {professionalName} know that you invited them to join Zocdoc so you can book with them online. Thank you!',
    },
    DoctorsEmail: {
        id: 'Profile.Components.InviteDoctorForm.DoctorsEmail',
        defaultMessage: 'Doctor\'s email',
    },
    EmailAddressPlaceholder: {
        id: 'Profile.Components.InviteDoctorForm.EmailAddressPlaceholder',
        defaultMessage: 'email address',
    },
    YourFirstName: {
        id: 'Profile.Components.InviteDoctorForm.YourFirstName',
        defaultMessage: 'Your first name',
    },
    FirstNamePlaceholder: {
        id: 'Profile.Components.InviteDoctorForm.FirstNamePlaceholder',
        defaultMessage: 'first name',
    },
    YourLastName: {
        id: 'Profile.Components.InviteDoctorForm.YourLastName',
        defaultMessage: 'Your last name',
    },
    LastNamePlaceholder: {
        id: 'Profile.Components.InviteDoctorForm.LastNamePlaceholder',
        defaultMessage: 'last name',
    },
    Send: {
        id: 'Profile.Components.InviteDoctorForm.Send',
        defaultMessage: 'Send',
    },
    NotAvailable: {
        id: 'Profile.Components.InviteDoctorForm.NotAvailable',
        defaultMessage: 'Unfortunately, you can’t book with this {specialtyName} on Zocdoc right now.',
    },
    AreYouDoctor: {
        id: 'Profile.Components.InviteDoctorForm.AreYouDoctor',
        defaultMessage: 'Are you {nameInSentence}?',
    },
    FindSimilarDoctors: {
        id: 'Profile.Components.InviteDoctorForm.FindSimilarDoctors',
        defaultMessage: 'Find similar doctors near you',
    },
    ClaimProfile: {
        id: 'Profile.Components.InviteDoctorForm.ClaimProfile',
        defaultMessage: 'Claim your profile',
    },
    FindAnotherDoctor: {
        id: 'Profile.Components.InviteDoctorForm.FindAnotherDoctor',
        defaultMessage: 'Find another doctor',
    },
    PleaseEnterAValidEmail: {
        id: 'Profile.Components.InviteDoctorForm.PleaseEnterAValidEmail',
        defaultMessage: 'Please enter a valid email address',
    },
    PleaseEnterAFirstName: {
        id: 'Profile.Components.InviteDoctorForm.PleaseEnterAFirstName',
        defaultMessage: 'Please enter a first name',
    },
    PleaseEnterALastName: {
        id: 'Profile.Components.InviteDoctorForm.PleaseEnterALastName',
        defaultMessage: 'Please enter a last name',
    },
    SomethingWentWrong: {
        id: 'Profile.Components.InviteDoctorForm.SomethingWentWrong',
        defaultMessage: 'Something went wrong...',
    },
});
